"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gameHeight_1 = __importDefault(require("../constants/gameHeight"));
const gameWidth_1 = __importDefault(require("../constants/gameWidth"));
const timePerIndicatorFrame_1 = __importDefault(require("../constants/timePerIndicatorFrame"));
const unitsPerTile_1 = __importDefault(require("../constants/unitsPerTile"));
const CollisionType_1 = __importDefault(require("../enums/CollisionType"));
const ZIndexType_1 = __importDefault(require("../enums/ZIndexType"));
const getTileset_1 = __importDefault(require("../functions/definables/getTileset"));
const drawImage_1 = __importDefault(require("../functions/draw/drawImage"));
const getCameraScreenCoords_1 = __importDefault(require("../functions/getCameraScreenCoords"));
const levelIsCompleted_1 = __importDefault(require("../functions/levelIsCompleted"));
const state_1 = __importDefault(require("../state"));
const Definable_1 = __importDefault(require("./Definable"));
class Tilemap extends Definable_1.default {
    constructor(slug, data) {
        super(slug);
        this._data = data;
    }
    get tileWidth() {
        return this._data.tilewidth;
    }
    get tileHeight() {
        return this._data.tileheight;
    }
    draw() {
        for (const layer of this._data.layers) {
            if (layer.name !== "collision") {
                this.drawLayer(layer);
            }
        }
    }
    getScreenCoordsFromCoords(coords) {
        const cameraScreenCoords = (0, getCameraScreenCoords_1.default)();
        return {
            x: Math.floor(cameraScreenCoords.x
                + (coords.x / unitsPerTile_1.default * this.tileWidth / 2)
                - (coords.y / unitsPerTile_1.default * this.tileWidth / 2)
                - 1),
            y: Math.floor(cameraScreenCoords.y
                + (coords.x / unitsPerTile_1.default * this.tileHeight / 2)
                + (coords.y / unitsPerTile_1.default * this.tileHeight / 2)
                - 6)
        };
    }
    getCoordsFromScreenCoords(screenCoords) {
        const cameraScreenCoords = (0, getCameraScreenCoords_1.default)();
        return {
            x: Math.round((screenCoords.x - cameraScreenCoords.x + 1) / this.tileWidth * unitsPerTile_1.default
                + (screenCoords.y - cameraScreenCoords.y + 6) / this.tileHeight * unitsPerTile_1.default),
            y: Math.round((screenCoords.y - cameraScreenCoords.y + 6) / this.tileHeight * unitsPerTile_1.default
                - (screenCoords.x - cameraScreenCoords.x + 1) / this.tileWidth * unitsPerTile_1.default)
        };
    }
    getCollisionAtCoords(coords) {
        const tileX = Math.round(coords.x / unitsPerTile_1.default);
        const tileY = Math.round(coords.y / unitsPerTile_1.default);
        for (const layer of this._data.layers) {
            if (layer.visible) {
                for (const chunk of layer.chunks) {
                    let datumIndex = 0;
                    for (const datum of chunk.data) {
                        const datumX = datumIndex % chunk.width;
                        const datumY = Math.floor(datumIndex / chunk.width);
                        const datumTileX = chunk.x + datumX;
                        const datumTileY = chunk.y + datumY;
                        switch (layer.name) {
                            case "floor": {
                                if (datum === 0 && datumTileX === tileX && datumTileY === tileY) {
                                    return CollisionType_1.default.Bonk;
                                }
                                break;
                            }
                            case "collision": {
                                if (datum > 0 && datumTileX === tileX && datumTileY === tileY) {
                                    return CollisionType_1.default.Bonk;
                                }
                                break;
                            }
                            case "obstacles": {
                                if (datum > 0 && datumTileX === tileX - 1 && datumTileY === tileY - 1) {
                                    return CollisionType_1.default.Obstacle;
                                }
                                break;
                            }
                        }
                        datumIndex++;
                    }
                }
            }
        }
        return null;
    }
    getDestructibleWithinRange() {
        var _a, _b, _c;
        const tileX = state_1.default.cootsCoords.x / unitsPerTile_1.default;
        const tileY = state_1.default.cootsCoords.y / unitsPerTile_1.default;
        for (const layer of this._data.layers) {
            if (layer.visible && (layer.name === "furniture" || layer.name === "floor-furniture")) {
                for (const chunk of layer.chunks) {
                    let datumIndex = 0;
                    for (const datum of chunk.data) {
                        if (datum > 0) {
                            const datumX = datumIndex % chunk.width + 1;
                            const datumY = Math.floor(datumIndex / chunk.width) + 1;
                            const datumTileX = chunk.x + datumX;
                            const datumTileY = chunk.y + datumY;
                            const tileset = this.getDatumTileset(datum);
                            const tilesetIndex = this.getDatumTilesetIndex(datum);
                            const tile = tileset.tiles.find((tile) => tile.id === tilesetIndex);
                            const destructibleIDProperty = tile && ((_a = tile.properties) === null || _a === void 0 ? void 0 : _a.find((property) => property.name === "destructibleID"));
                            const destructibleID = destructibleIDProperty === null || destructibleIDProperty === void 0 ? void 0 : destructibleIDProperty.value;
                            const uninteractableProperty = tile && ((_b = tile.properties) === null || _b === void 0 ? void 0 : _b.find((property) => property.name === "uninteractable"));
                            const uninteractable = uninteractableProperty === null || uninteractableProperty === void 0 ? void 0 : uninteractableProperty.value;
                            const destructibleNoiseProperty = tile && ((_c = tile.properties) === null || _c === void 0 ? void 0 : _c.find((property) => property.name === "destructibleNoise"));
                            const destructibleNoise = destructibleNoiseProperty === null || destructibleNoiseProperty === void 0 ? void 0 : destructibleNoiseProperty.value;
                            const scratchRange = 2;
                            if (datum > 0 && Math.abs(tileX - datumTileX) <= scratchRange && Math.abs(tileY - datumTileY) <= scratchRange && typeof destructibleID === "string" && !uninteractable) {
                                if (state_1.default.brokenDestructibleIDs.includes(destructibleID) === false && state_1.default.activeDestructibleIDs.includes(destructibleID)) {
                                    return {
                                        destructibleID,
                                        tileID: tilesetIndex,
                                        audioSourceSlug: typeof destructibleNoise === "string" ? `noises/destroy/${destructibleNoise}` : null
                                    };
                                }
                            }
                        }
                        datumIndex++;
                    }
                }
            }
        }
        return null;
    }
    getUnbrokenDestructibles() {
        var _a;
        const destructibles = [];
        for (const layer of this._data.layers) {
            if (layer.visible && (layer.name === "furniture" || layer.name === "floor-furniture")) {
                for (const chunk of layer.chunks) {
                    let datumIndex = 0;
                    for (const datum of chunk.data) {
                        if (datum > 0) {
                            const tileset = this.getDatumTileset(datum);
                            const tilesetIndex = this.getDatumTilesetIndex(datum);
                            const tile = tileset.tiles.find((tile) => tile.id === tilesetIndex);
                            const property = (_a = tile === null || tile === void 0 ? void 0 : tile.properties) === null || _a === void 0 ? void 0 : _a.find((property) => property.name === "destructibleID");
                            const destructibleID = property === null || property === void 0 ? void 0 : property.value;
                            if (typeof destructibleID === "string" && destructibles.includes(destructibleID) === false && state_1.default.brokenDestructibleIDs.includes(destructibleID) === false) {
                                destructibles.push(destructibleID);
                            }
                        }
                    }
                }
            }
        }
        return destructibles;
    }
    drawLayer(layer) {
        var _a, _b, _c, _d;
        const cameraScreenCoords = (0, getCameraScreenCoords_1.default)();
        if (layer.visible) {
            for (const chunk of layer.chunks) {
                let datumIndex = 0;
                for (const datum of chunk.data) {
                    if (datum > 0) {
                        const datumX = datumIndex % chunk.width;
                        const datumY = Math.floor(datumIndex / chunk.width);
                        const tileset = this.getDatumTileset(datum);
                        const tilesetIndex = this.getDatumTilesetIndex(datum);
                        const tile = tileset.tiles.find((tile) => tile.id === tilesetIndex);
                        const destructibleIDProperty = tile && ((_a = tile.properties) === null || _a === void 0 ? void 0 : _a.find((property) => property.name === "destructibleID"));
                        const destructibleID = destructibleIDProperty === null || destructibleIDProperty === void 0 ? void 0 : destructibleIDProperty.value;
                        const brokenIDProperty = tile && ((_b = tile.properties) === null || _b === void 0 ? void 0 : _b.find((property) => property.name === "brokenID"));
                        const brokenID = brokenIDProperty === null || brokenIDProperty === void 0 ? void 0 : brokenIDProperty.value;
                        const isDestroyed = typeof destructibleID === "string" && state_1.default.brokenDestructibleIDs.includes(destructibleID);
                        const calculatedTilesetIndex = isDestroyed && typeof brokenID === "number"
                            ? brokenID
                            : this.getDatumTilesetIndex(datum);
                        const tileSourceX = (calculatedTilesetIndex % tileset.columns) * tileset.tileWidth;
                        const tileSourceY = Math.floor(calculatedTilesetIndex / tileset.columns) * tileset.tileHeight;
                        const tileX = Math.floor(cameraScreenCoords.x
                            + (datumX * this.tileWidth / 2)
                            - (datumY * this.tileWidth / 2)
                            + (chunk.x * this.tileWidth / 2)
                            - (chunk.y * this.tileWidth / 2)
                            - (this.tileWidth / 2));
                        const tileY = Math.floor(cameraScreenCoords.y
                            + (datumX * this.tileHeight / 2)
                            + (datumY * this.tileHeight / 2)
                            + (chunk.x * this.tileHeight / 2)
                            + (chunk.y * this.tileHeight / 2)
                            - this.tileHeight);
                        const ySortID = layer.name === "furniture" ? `${layer.name}/${tileX}/${tileY}` : null;
                        const ySortZIndex = ySortID
                            ? {
                                ySortID,
                                type: ZIndexType_1.default.YSort
                            }
                            : null;
                        const furnitureUpperZIndex = {
                            value: 10000,
                            type: ZIndexType_1.default.Hard
                        };
                        const zIndex = (layer.name === "upper-furniture") ? furnitureUpperZIndex : ySortZIndex;
                        (0, drawImage_1.default)(`tilesets/${tileset.slug}`, 1, tileSourceX, tileSourceY, tileset.tileWidth, tileset.tileHeight, tileX, tileY, tileset.tileWidth, tileset.tileHeight, zIndex);
                        if (layer.name === "floor") {
                            if (state_1.default.level.startingTileX === datumX + chunk.x && state_1.default.level.startingTileY === datumY + chunk.y) {
                                const bedZIndex = {
                                    type: ZIndexType_1.default.Hard,
                                    value: .1,
                                };
                                (0, drawImage_1.default)("bed", 1, 18 * state_1.default.level.bed, 0, 18, 12, tileX + 3, tileY - 1, 18, 12, bedZIndex);
                            }
                        }
                        if (state_1.default.hasRecentDestruction() && state_1.default.recentDestruction.destructibleID === destructibleID && state_1.default.recentDestruction.tileID === tilesetIndex) {
                            const diff = state_1.default.currentTime - state_1.default.recentDestruction.clawedAt;
                            const frame = Math.floor(diff / 100);
                            if (frame <= 4) {
                                const scratchZIndex = {
                                    value: 10000,
                                    type: ZIndexType_1.default.Hard
                                };
                                (0, drawImage_1.default)("scratch", 1, frame * 16, 0, 16, 16, tileX, tileY, 16, 16, scratchZIndex);
                            }
                        }
                        if ((0, levelIsCompleted_1.default)() === false && (layer.name === "furniture" || layer.name === "floor-furniture")) {
                            if (typeof destructibleID === "string" && !isDestroyed && state_1.default.activeDestructibleIDs.includes(destructibleID)) {
                                const indicatorXOffsetProperty = tile && ((_c = tile.properties) === null || _c === void 0 ? void 0 : _c.find((property) => property.name === "indicatorXOffset"));
                                const indicatorXOffset = indicatorXOffsetProperty === null || indicatorXOffsetProperty === void 0 ? void 0 : indicatorXOffsetProperty.value;
                                const indicatorYOffsetProperty = tile && ((_d = tile.properties) === null || _d === void 0 ? void 0 : _d.find((property) => property.name === "indicatorYOffset"));
                                const indicatorYOffset = indicatorYOffsetProperty === null || indicatorYOffsetProperty === void 0 ? void 0 : indicatorYOffsetProperty.value;
                                if (typeof indicatorXOffset === "number" && typeof indicatorYOffset === "number") {
                                    const hardZIndex = {
                                        value: 10001,
                                        type: ZIndexType_1.default.Hard
                                    };
                                    const frameAnimationOffset = Math.floor((state_1.default.currentTime % (timePerIndicatorFrame_1.default * 4)) / timePerIndicatorFrame_1.default) * 7;
                                    let indicatorX = tileX + indicatorXOffset;
                                    let indicatorY = tileY + indicatorYOffset;
                                    const indicatorWidth = 7;
                                    const indicatorHeight = 10;
                                    const arrowOffset = 4;
                                    const minX = arrowOffset;
                                    const counterHUDX = 103;
                                    const counterHUDY = 17;
                                    const timerHUDX = 49 + indicatorWidth;
                                    const timerHUDY = 18;
                                    const clawHUDX = 42;
                                    const clawHUDY = 36 + indicatorHeight;
                                    if (indicatorX < counterHUDX && indicatorY < counterHUDY) {
                                        const diffX = indicatorX - counterHUDX;
                                        const diffY = indicatorY - counterHUDY;
                                        if (diffX > diffY) {
                                            indicatorX = counterHUDX;
                                        }
                                        else {
                                            indicatorY = counterHUDY;
                                        }
                                    }
                                    if (indicatorX > gameWidth_1.default - timerHUDX && indicatorY < timerHUDY) {
                                        const diffX = gameWidth_1.default - indicatorX - timerHUDX;
                                        const diffY = indicatorY - timerHUDY;
                                        if (diffX > diffY) {
                                            indicatorX = gameWidth_1.default - timerHUDX;
                                        }
                                        else {
                                            indicatorY = timerHUDY;
                                        }
                                    }
                                    if (indicatorX < clawHUDX && indicatorY > gameHeight_1.default - clawHUDY) {
                                        const diffX = indicatorX - clawHUDX;
                                        const diffY = gameHeight_1.default - indicatorY - clawHUDY;
                                        if (diffX > diffY) {
                                            indicatorX = clawHUDX;
                                        }
                                        else {
                                            indicatorY = gameHeight_1.default - clawHUDY;
                                        }
                                    }
                                    if (indicatorX < minX) {
                                        indicatorX = minX;
                                    }
                                    const maxX = gameWidth_1.default - arrowOffset - indicatorWidth;
                                    if (indicatorX > maxX) {
                                        indicatorX = maxX;
                                    }
                                    const minY = arrowOffset;
                                    if (indicatorY < minY) {
                                        indicatorY = minY;
                                    }
                                    const maxY = gameHeight_1.default - arrowOffset - indicatorHeight;
                                    if (indicatorY > maxY) {
                                        indicatorY = maxY;
                                    }
                                    (0, drawImage_1.default)("indicator", 1, frameAnimationOffset, 0, indicatorWidth, indicatorHeight, indicatorX, indicatorY, indicatorWidth, indicatorHeight, hardZIndex);
                                }
                            }
                        }
                    }
                    datumIndex++;
                }
                ;
            }
        }
    }
    getDatumTileset(datum) {
        const gid = datum;
        const found = [...this._data.tilesets].reverse().find(({ firstgid }) => gid >= firstgid);
        if (!found) {
            throw new Error(`Could not get Tileset for datum ${datum} of Tilemap "${this.slug}"`);
        }
        const tilesetSlug = found.source.substring(12, found.source.length - 5);
        return (0, getTileset_1.default)(tilesetSlug);
    }
    getDatumTilesetIndex(datum) {
        const gid = datum;
        const found = [...this._data.tilesets].reverse().find(({ firstgid }) => gid >= firstgid);
        if (!found) {
            throw new Error(`Could not get Tileset for datum ${datum} of Tilemap "${this.slug}"`);
        }
        return gid - found.firstgid;
    }
}
exports.default = Tilemap;
